import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-year-select',
	templateUrl: 'year-selector.template.html'
})

/**
 * Custom input component used for switching between years in a given range
 */
export class YearSelectorComponent
{
	/**
	 * The range of the years that can be selected
	 *
	 * @type {number}
	 */
	@Input() range = 20;

	/**
	 * Event that fires when the year value is changed. Contains the current selected year.
	 *
	 * @type {EventEmitter<number>}
	 */
	@Output() onValueChange = new EventEmitter<number>();

	_value: number;

	get value(): number
	{
		return this._value
	}

	set value(value: number)
	{
		this._value = value;
		this.onValueChange.emit(value);
	}

	currentYear: number;

	/**
	 * YearSelectorComponent constructor
	 */
	constructor()
	{
		this.value = (new Date()).getFullYear();
		this.currentYear = this.value;
	}

	/**
	 * Selects the next year
	 *
	 * @returns void
	 */
	next()
	{
		if (this.value < this.currentYear + this.range) {
			this.value++;
		}
		else {
			this.value = this.currentYear - this.range;
		}
	}

	/**
	 * Selects the previous year
	 *
	 * @returns void
	 */
	prev()
	{
		if (this.value > this.currentYear - this.range) {
			this.value--;
		}
		else {
			this.value = this.currentYear + this.range;
		}
	}

	/**
	 * Selects the year to the current year
	 *
	 * @returns void
	 */
	reset()
	{
		this.value = this.currentYear;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/input/year-selector.component.ts